import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  option: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '22px 0'
  },
  animalInfo: {
    display: 'flex',
    flexDirection: 'column'
  },
  animalName: {
    color: theme.palette.primary.main,
    fontWeight: 500
  },
  animalNumber: {
    marginTop: 2,
    fontSize: theme.app.typography.small.fontSize,
    color: theme.app.colors.text.secondary
  },
  sexIcon: {
    fontSize: '18px !important',
    display: 'flex',
    alignItems: 'center',
    '& > svg': {
      width: '18px !important',
      height: '18px !important',
      '& path': {
        fill: theme.palette.primary.main
      }
    }
  },
  femaleIcon: {
    color: theme.palette.primary.main,
    '& > svg path': {
      fill: theme.palette.primary.main
    }
  },
  maleIcon: {
    color: theme.palette.primary.main,
    '& > svg path': {
      fill: theme.palette.primary.main
    }
  }
}))
